import { InjectionToken } from '@angular/core';

/**
 * Configuration for S3ConfigService
 */
export interface S3ConfigServiceConfig {
  /** URL to fetch S3/UI configuration JSON (e.g. location provider) */
  s3ConfigUrl: string;
  /** Optional application key for app-specific configuration lookup */
  appName?: string;
}

/**
 * Injection token for S3ConfigService configuration
 *
 * @example
 * ```typescript
 * providers: [
 *   {
 *     provide: S3_CONFIG_SERVICE_CONFIG,
 *     useValue: {
 *       s3ConfigUrl: environment.s3ConfigUrl,
 *       appName: 'web-consumer'
 *     }
 *   }
 * ]
 * ```
 */
export const S3_CONFIG_SERVICE_CONFIG = new InjectionToken<S3ConfigServiceConfig>('S3_CONFIG_SERVICE_CONFIG');
